import React, { memo, useState } from 'react';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { PhoneLink } from 'web-ui-components/lib/actions/links';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Content } from '../infrastructure/content';
import { InformationModal } from 'web-ui-components/lib/layout/content';
import { SubHeading } from 'web-ui-components/lib/typography/headings';

const Help = memo(function Help() {
  const [isHelpModalOpen, toggleHelpModal] = useState(false);
  return (
    <Content>
      {({
        headerHelpButtonTitle,
        helpModalTitle,
        helpModalContentA,
        helpModalContentB,
        helpModalContentC,
        helpModalContentD,
        helpModalContentE,
        helpModalContentNo
      }) => (
        <>
          <Button
            onClick={e => {
              e.preventDefault();
              toggleHelpModal(true);
            }}
            width="flush"
          >
            {headerHelpButtonTitle}
          </Button>
          <InformationModal
            titleText={
              <SubHeading icon={<Icon iconType="Help" />}>
                <span>{helpModalTitle}</span>
              </SubHeading>
            }
            isOpen={isHelpModalOpen}
            onClose={e => {
              e.preventDefault();
              toggleHelpModal(!isHelpModalOpen);
            }}
          >
            <StandardBody>
              <p>
                {helpModalContentA} <br />
                <PhoneLink phoneNumber={helpModalContentB} />
              </p>
              <p>
                {helpModalContentC} <br /> <PhoneLink phoneNumber={helpModalContentNo} />
              </p>
              <p>{helpModalContentD}</p>
              <p>{helpModalContentE}</p>
            </StandardBody>
          </InformationModal>
        </>
      )}
    </Content>
  );
});

export { Help };
